<template>
  <div class="space-y-6">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">Positions</h1>
      <p class="text-muted-foreground">
        Manage your options positions and track your investments.
      </p>
    </div>
    
    <PositionsManager />
  </div>
</template>

<script setup lang="ts">
import PositionsManager from '@/components/PositionsManager.vue'
</script>
